import 'apps/personal/styles/components/targets-personal-target-modal.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'library/util/core-router';
import withUser from 'util/hoc/with-user';
import Modal from 'library/helpers/modal';
import TargetWorkFlowStart from 'apps/personal/components/target-workflows/start';
import TargetWorkflowDescription from 'apps/personal/components/target-workflows/description';
import TargetWorkflowPicker from 'apps/personal/components/target-workflows/picker';
import TargetWorkflowScience from 'apps/personal/components/target-workflows/science';

class ModalInner extends React.Component {
  static propTypes = {
    close: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    onComplete: PropTypes.func.isRequired
  }

  static childContextTypes = {
    user: PropTypes.object
  }

  getChildContext() {
    return {
      user: this.props.user
    };
  }

  state = {
    workflow: null
  }

  updateWorkflow = (workflowName) => {
    if (workflowName === null) return null;

    return this.setState({workflow: workflowName});
  }

  resetWorkflow = () => {
    return this.setState({workflow: null});
  }

  render() {
    return (
      <div className='personal-target-modal-inner'>
        {!this.state.workflow &&
          <TargetWorkFlowStart close={this.props.close} next={(workflowName)=>this.updateWorkflow(workflowName)} />
        }
        {!!this.state.workflow && this.state.workflow === 'description' &&
          <TargetWorkflowDescription
            reset={this.resetWorkflow}
            user={this.props.user}
            close={this.props.close}
            onComplete={this.props.onComplete}
          />
        }
        {!!this.state.workflow && this.state.workflow === 'science' &&
          <TargetWorkflowScience
            reset={this.resetWorkflow}
            user={this.props.user}
            close={this.props.close}
            onComplete={this.props.onComplete}
          />
        }
        {!!this.state.workflow && this.state.workflow === 'picker' &&
          <TargetWorkflowPicker
            reset={this.resetWorkflow}
            user={this.props.user}
            close={this.props.close}
            onComplete={this.props.onComplete}
          />
        }
      </div>
    )
  }
}

class PersonalTargetModal extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    onComplete: PropTypes.func.isRequired,
    history: PropTypes.object
  }

  static defaultProps = {
    user: {},
    onComplete: ()=>{}
  }

  componentDidMount() {
    this.mount();
  }

  componentWillReceiveProps(nextProps) {
    this.doRender(nextProps);
  }

  componentWillUnmount() {
    if (this.modal) {
      this.modal.element.removeEventListener('click', this.handleClick);
      this.modal.unmount();
    }
  }

  doRender = () => {
    if (this.modal) {
      this.modal.render(ModalInner, {
        onComplete: (...params)=>{
          this.props.onComplete(...params);
          this.close();
        },
        close: this.close,
        user: this.props.user
      });
    }
  }

  handleClick = (e) => {
    if (e.target === e.currentTarget) {
      this.close();
    }
  }

  close = () => {
    this.props.history.push('/personal');
  }

  mount = () => {
    if (!this.modal) {
      this.modal = new Modal('personal-target-modal',true, {
        className: 'personal-target-modal'
      });
      this.modal.element.addEventListener('click', this.handleClick);
    }

    this.doRender(this.props);
  }

  render() {
    return null;
  }
}

export default withRouter(withUser(PersonalTargetModal));
